<template>
  <div class="container-fluid mt-4 SlimTDs">
    <b-row class="mb-3 pb-1 border-bottom">
      <b-col>
        <span :class="`size-${ButtonSize}`">Salon Düzenle</span>
      </b-col>

      <b-col cols="auto" class="text-right">
        <b-btn class="mr-3" type="button" variant="danger" to="/Settings/Places" :size="ButtonSize">
          <i class="material-icons mifix">arrow_back</i>
          <span class="ml-1" v-if="ScreenWidth > 380">Salonlar</span>
        </b-btn>

        <b-btn class="mr-3" type="button" variant="info" @click="Refresh()" :size="ButtonSize">
          <i class="material-icons mifix">refresh</i>
          <span class="ml-1" v-if="ScreenWidth > 360">Yenile</span>
        </b-btn>
      </b-col>
    </b-row>

    <b-alert show variant="danger" v-if="Object.keys(Place).length === 0">Hata!</b-alert>

    <b-alert
      show
      variant="info"
      v-if="Object.keys(Place).length > 0"
    >Düzenlenen salon: {{ PlaceOldName }}</b-alert>

    <form @submit.prevent="SavePlace" v-if="Object.keys(Place).length > 0">
      <b-form-group
        class="formgroup"
        :label="Enums[index]"
        v-for="(property, index) in PlaceGUI"
        :key="index"
      >
        <b-form-input type="text" v-model="Place[index]" @keypress.enter.prevent="SavePlace"></b-form-input>
      </b-form-group>

      <div class="m-t-40 d-block border-top pt-3 pl-3">
        <b-btn type="submit" variant="success" size="lg">
          <i class="material-icons mifix">save</i>
          <span class="ml-1">Kaydet</span>
        </b-btn>
      </div>
    </form>
  </div>
</template>

<script>
import { mapState } from "vuex";
import Services from "../../Service";

export default {
  data() {
    return {
      Enums: {
        Name: "Salon Adı",
        Sort: "Sıralama"
      },
      PlaceOldName: "",
      Place: {}
    };
  },
  async created() {
    await this.Refresh();
  },
  computed: {
    ...mapState(["StoreData", "ScreenWidth", "ButtonSize"]),
    ParamID() {
      return this.$route.params.ID;
    },
    PlaceGUI() {
      return Object.filterKey(
        this.Place,
        x => ["Name", "Sort"].indexOf(x) !== -1
      );
    }
  },
  methods: {
    async Refresh() {
      if (!this.StoreData.Places) return;
      if (!this.StoreData.Places[this.ParamID]) return;

      let _Place = Object.assign({}, this.StoreData.Places[this.ParamID]);

      delete _Place.Tables;

      await this.$set(this, "PlaceOldName", _Place.Name);
      await this.$set(this, "Place", _Place);

      await this.$nextTick();
      await this.$forceUpdate();
    },
    async SavePlace() {
      await this.$store.dispatch("AddLoading", "SavePlace");

      await Services.Nozich.Send(
        "SavePlace",
        {
          ID: this.ParamID,
          Place: this.Place
        },
        async Data => {
          await this.$store.dispatch("RemoveLoading", "SavePlace");

          if (Data.Status === "Success") {
            await this.$router.push("/Settings/Places");
          }
        }
      );
    }
  },
  async mounted() {
    this.$store.subscribe(async () => {
      await this.$nextTick();
      await this.$forceUpdate();
    });
  }
};
</script>
